import { useEffect, useRef } from "react";

export default function Cursor() {
  const ref = useRef(null);

  useEffect(() => {
    const dot = ref.current;
    if (!dot) return;
    let x = 0, y = 0, tx = 0, ty = 0;

    const move = (e) => { tx = e.clientX; ty = e.clientY; };
    const enter = (e) => {
      const t = e.target.closest("a, button, [data-cursor='hover'], input, textarea, select, label");
      if (t) dot.classList.add("hover");
    };
    const leave = (e) => {
      const t = e.target.closest("a, button, [data-cursor='hover'], input, textarea, select, label");
      if (t) dot.classList.remove("hover");
    };

    document.addEventListener("mousemove", move);
    document.addEventListener("mouseover", enter);
    document.addEventListener("mouseout", leave);

    let raf;
    const tick = () => {
      x += (tx - x) * 0.22;
      y += (ty - y) * 0.22;
      dot.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", enter);
      document.removeEventListener("mouseout", leave);
    };
  }, []);

  return <div ref={ref} className="nv-cursor" aria-hidden="true" data-testid="custom-cursor" />;
}
